import { render, staticRenderFns } from "./Proche.vue?vue&type=template&id=324356c8&"
import script from "./Proche.vue?vue&type=script&lang=js&"
export * from "./Proche.vue?vue&type=script&lang=js&"
import style0 from "./Proche.vue?vue&type=style&index=0&id=324356c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports